var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goodsList && _vm.goodsList.length>0)?_c('div',{staticClass:"scan-cart",on:{"click":_vm.toScancartGoods}},[_c('img',{staticClass:"img",attrs:{"src":_vm.tabbar_cart_sel,"alt":"","srcset":""}}),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.cartNumber))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c09792","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/home/child/ScanCart.vue
// module id = null
// module chunks = 